import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskKbRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-kb',
	path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
	exact: true,
};
